// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"2b5540f2","72":"d8896f53","487":"de672560","503":"8ba9b287","541":"4a900ac2","559":"0b42560a","769":"c37bc5d4"}[chunkId] + ".chunk.js";
};